(function (window, document, $) {
	"use strict";

	$(document).ready(function () {
		var $root = $("html, body");

		// Copy the entire element to the clipboard
		$("a.jh-ks-copy-element").on("click", function (e) {
			e.preventDefault();

			var $this = $(this),
				$row = $this.closest(".row"),
				$element = "";

			if ($row.hasClass("dev-only")) {
				$element = $row.find(".functional-example a")[0].outerHTML;
			} else {
				$element = $row.find(".functional-example").html();
			}

			jh_ks_copy_to_clipboard($element);
		});

		// Copy just the element classes to the clipboard
		$("a.jh-ks-copy-element-classes").on("click", function (e) {
			e.preventDefault();

			var $this = $(this),
				$row = $this.closest(".row"),
				$elementClasses = "";

			if ($row.hasClass("dev-only")) {
				$elementClasses = $row
					.find(".functional-example a.jh-btn")
					.attr("class");
			} else {
				$elementClasses = $row
					.find(".functional-example > *")
					.attr("class");
			}

			jh_ks_copy_to_clipboard($elementClasses);
		});

		// Toggle the .icon-close class (only on links) to reduce the space between icons and text
		$("a.jh-ks-tighten-up").on("click", function (e) {
			e.preventDefault();

			var $this = $(this),
				$row = $this.closest(".row");

			$row.find(".jh-link").toggleClass("icon-close");

			if ("Tighten spacing" === $this.text()) {
				$this.text("Loosen spacing");
			} else {
				$this.text("Tighten spacing");
			}
		});

		// Expanding/collapsing of sections in the Kitchen Sink nav
		$(".ks-nav-group .nav-section-title").on("click", function (e) {
			var $this = $(this);
			// Close all other open list items
			$(".ks-nav-group .nav-section-title")
				.not($this)
				.removeClass("is-open")
				.parent()
				.find(".ks-nav-items")
				.slideUp(150);
			// Now open the clicked list item
			$this.toggleClass("is-open");
			$this.parent().find(".ks-nav-items").slideToggle(150);
		});

		// Expanding/collapsing the entire Kitchen Sink nav
		$(".ks-navigation-toggle").on("click", function (e) {
			e.preventDefault();
			var $this = $(this);
			$(".ks-nav-group .nav-section-title")
				.removeClass("is-open")
				.parent()
				.find(".ks-nav-items")
				.slideUp(150);
			$this.closest(".ks-navigation").find(".ks-nav-group").toggle();
			$this.closest(".ks-navigation").toggleClass("reduced");
		});

		// Toggle the visibility of the disabled button variants to reduce button section height by 50%
		$(".jh-ks-hide-disabled-button-variants").on("click", function (e) {
			e.preventDefault();

			var $this = $(this);

			if ("Hide disabled button variants" === $this.text()) {
				$this.text("Show disabled button variants");
			} else {
				$this.text("Hide disabled button variants");
			}

			$(
				".ks-section.ks-buttons .row.disabled:not(.dev-only)"
			).toggleClass("show-variant");
		});

		// Toggle the visibility of the dev-only variants
		$(".jh-ks-hide-dev-only-button-variants").on("click", function (e) {
			e.preventDefault();

			var $this = $(this);

			if ("Hide dev-only button variants" === $this.text()) {
				$this.text("Show dev-only button variants");
			} else {
				$this.text("Hide dev-only button variants");
			}

			$(
				".ks-section.ks-buttons .row.dev-only, .ks-section.ks-buttons .row.disabled.dev-only"
			).toggleClass("show-variant");
		});

		// Smooth scrolling
		$(".scrolling-link").on("click", function (e) {
			e.preventDefault();

			$root.animate(
				{
					scrollTop: $($.attr(this, "href")).offset().top - 16,
				},
				500
			);
		});

		// Toggle Dark Mode
		$(".toggle-dark-mode").on("click", function (e) {
			e.preventDefault();
			var parentContainer = $(this).closest(".dark-mode-available");
			parentContainer.toggleClass("jh-dark-mode-links");
			$(this).children(".switch-text").toggle();
		});

		// Close .ks-navigation when clicking outside of it
		$(document).on("click", function (e) {
			var $nav = $(".ks-navigation");
			var $toggle = $(".ks-navigation-toggle");

			// Check if the click is outside the navigation and toggle button
			if (
				!$nav.is(e.target) &&
				$nav.has(e.target).length === 0 &&
				!$toggle.is(e.target) &&
				$toggle.has(e.target).length === 0
			) {
				$nav.addClass("reduced"); // Close the navigation
				$nav.find(".ks-nav-group").hide(); // Hide the nav group
			}
		});
	});

	function jh_ks_copy_to_clipboard(content) {
		// Create a temporary input element
		var tempInput = document.createElement("input");

		// Set its value to the passed-in content parameter
		tempInput.setAttribute("value", content.trim());

		// Append the temporary input to the document
		document.body.appendChild(tempInput);

		// Select the temporary input
		tempInput.select();

		// Copy the value of the temporary input to the clipboard
		document.execCommand("copy");

		// Remove the temporary input
		document.body.removeChild(tempInput);
	}

	// Adds functionality to the "Copy" button in the pre elements.
	$(".ks-copy-button_copy-btn").click(function () {
		console.log("Copy button clicked");
		// Create a temporary input field
		var $temp = $("<input>");
		$("body").append($temp);
		// Add the text to that temp input field and select the text
		var copyText = $(this).parent().siblings(".ks-code-block_text").text();
		console.log("Copy button clicked");
		$temp.val(copyText).select();
		// Copy to clipboard then remove the temp input field
		document.execCommand("copy");
		$temp.remove();
		// Update Tooltip
		$(this)
			.siblings(".ks-copy-button_tooltip")
			.html("Copied: " + copyText);
	});

	$(".ks-copy-button_copy-btn").hover(
		function () {
			$(this).siblings(".ks-copy-button_tooltip").fadeToggle("fast");
		},
		function () {
			$(this)
				.siblings(".ks-copy-button_tooltip")
				.hide()
				.html("Copy to Clipboard");
		}
	);

	// Adds functionality to the "Copy" button in the typography elements.
	$(".ks-copy-typography-class__button").on("click", function () {
		// Get the text from the data-text attribute
		var textToCopy = $(this).data("text");

		// Create a temporary textarea element to hold the text to be copied
		var $temp = $("<textarea>");
		$("body").append($temp);
		$temp.val(textToCopy).select(); // Set the value and select it

		// Copy the text to the clipboard
		document.execCommand("copy");

		// Remove the temporary textarea
		$temp.remove();

		// Show the tooltip for a brief moment
		var $tooltip = $(this).siblings(".ks-copy-typography-class__tooltip");
		$tooltip.text("Copied '" + textToCopy + "' to your clipboard");
		$tooltip.fadeIn(200); // Fade in the tooltip to measure its height
		var height = $tooltip.outerHeight() + 10; // Measure the height and add some offset
		$tooltip.css("top", -height + "px"); // Adjust the top position
		setTimeout(function () {
			$tooltip.fadeOut(250); // Fade out the tooltip
		}, 3000);
	});

	// Adds copy text block functionality.
	$(".ks-copy-text-block__button").on("click", function () {
		var $this = $(this);
		var targetSelector = $this.data("target");
		var $target = $(targetSelector);

		// Create a temporary textarea element to hold the text to be copied
		var $temp = $("<textarea>");
		$("body").append($temp);
		$temp.val($target.prop("outerHTML")).select(); // Set the value and select it

		// Copy the text to the clipboard
		document.execCommand("copy");

		// Remove the temporary textarea
		$temp.remove();

		// Show the tooltip for a brief moment
		var $tooltip = $this.siblings(".ks-copy-typography-class__tooltip");
		$tooltip.text("Copied HTML to your clipboard");
		$tooltip.fadeIn(200); // Fade in the tooltip to measure its height
		var height = $tooltip.outerHeight() + 10; // Measure the height and add some offset
		$tooltip.css("top", -height + "px"); // Adjust the top position
		setTimeout(function () {
			$tooltip.fadeOut(200); // Fade out the tooltip
		}, 2000);
	});
})(window, document, jQuery);
